<template>
    <div>
        <v-toolbar @click="navigation_dialog = true"
                   flat
                   color="transparent">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>

            <v-toolbar-title>
                <span :style="'color:'+content.text_color+';'">
                    {{ content.value }}
                </span>
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn text
                   :color="content.text_color"
                   v-for="item in content.items">
                {{ item.text }}
            </v-btn>
        </v-toolbar>

        <blocks-models-navigation-block
                :is_visible="navigation_dialog"
                :close_function="close_dialog"
                :item="content"
        >

        </blocks-models-navigation-block>
    </div>
</template>

<script>
import BlocksModelsNavigationBlock from "@/components/Blocks/Models/NavigationBlock.vue";
export default {
    props: {
        content: Object
    },
  components: {
    BlocksModelsNavigationBlock
  },
  data () {
    return {
      navigation_dialog: false
    }
  },
    methods: {
        close_dialog: function() {
            this.navigation_dialog = false;
        }
    }
}
</script>
